module.exports = __webpack_public_path__ + "img/bofang.50963163.svg";